/**
 * 移入批次抽屉：「无法移入」区（转写自原型 moveOrphans / copyOrphansAll）。
 */
import { CopyOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { MoveInOrphan } from '../types';
import { AlreadyInBatch, useCopyNumbers } from './MoveInShared';

export const MoveInOrphanList: React.FC<{ orphans: MoveInOrphan[] }> = ({ orphans }) => {
    const { t } = useTranslation();
    const copyNumbers = useCopyNumbers();
    if (!orphans.length) return null;
    return (
        <div className="overflow-hidden rounded border border-solid border-[#ffccc7]">
            <div className="flex items-center gap-2.5 border-0 border-b border-solid border-[#ffccc7] bg-[#fff1f0] px-3 py-2">
                <span className="flex-1 text-[12.5px] font-medium text-[#a8071a]">{t('wms.sortingBatch.moveIn.orphansTitle')}</span>
                <Button size="small" danger onClick={() => copyNumbers(orphans.map((o) => o.number))}>
                    {t('wms.sortingBatch.moveIn.copyAll')}
                </Button>
            </div>
            {orphans.map((o, i) => (
                <div key={`${o.number}-${i}`} className="flex items-center gap-2.5 border-0 border-b border-solid border-[#f2f3f5] px-3 py-2">
                    <span className="w-10 flex-none text-[11.5px] text-[#86909c]">
                        {o.isBag ? t('wms.sortingBatch.common.bag') : t('wms.sortingBatch.common.parcel')}
                    </span>
                    {/* 号码完整展示不截断：列宽按内容撑开，min-w 让常见长度的号码各行对齐 */}
                    <span className="flex min-w-[200px] flex-none items-center gap-1.5">
                        <span className="whitespace-nowrap font-mono text-[12.5px]">{o.number}</span>
                        <Tooltip title={t('wms.sortingBatch.common.copy')}>
                            <Button
                                type="text"
                                size="small"
                                className="flex-none text-[#86909c]"
                                icon={<CopyOutlined />}
                                aria-label={t('wms.sortingBatch.common.copy') ?? undefined}
                                onClick={() => copyNumbers([o.number])}
                            />
                        </Tooltip>
                    </span>
                    <span className="w-20 flex-none font-mono text-xs text-[#4e5969]">{o.destination}</span>
                    <span className="flex min-w-0 flex-1 flex-wrap items-center justify-end gap-2">
                        {o.currentBatch ? <AlreadyInBatch batchNumber={o.currentBatch} /> : null}
                        <span className="text-xs text-[#f5222d]">{t(`wms.sortingBatch.moveIn.reason.${o.reason}`)}</span>
                    </span>
                </div>
            ))}
        </div>
    );
};
